import React from "react";
import { Wrapper } from "./error.styles";

export const Error = () => {
  return (
    <Wrapper>
      <h3>Sorry, there was an error retrieving your applications status.</h3>
      <p>
        Please try refreshing this page, or check that you followed the correct
        link from the email we sent you.
      </p>
    </Wrapper>
  );
};
